import React from 'react'
import PropTypes from 'prop-types'

import clsx from 'clsx'

import { FormControlLabel, Checkbox } from '@material-ui/core'

import useStyles from './styles'

const MultiSelectItem = ({
  item,
  selectAllByGroup = () => {},
  allSelectedByGroup = () => {},
  someSelectedByGroup = () => {},
  isForeign,
  checked,
  onClick = () => {},
  height,
}) => {
  const classes = useStyles()
  const isGroup = !!item?.isGroup

  const handleClick = (e) => {
    if (isGroup) {
      e.stopPropagation()
      e.preventDefault()
      return selectAllByGroup(item?.id)
    }

    if (!!onClick) {
      onClick(e)
    }
  }

  return (
    <FormControlLabel
      onClick={handleClick}
      classes={{
        root: clsx({
          [classes.formControlLabelRoot]: !isGroup && !isForeign,
          [classes.formControlLabelRootGroup]: isGroup || isForeign,
          [classes.checked]: checked,
        }),
        label: clsx({
          [classes.formControlLabelGroup]: !!isGroup,
        }),
      }}
      label={item?.label}
      labelPlacement="end"
      control={
        <Checkbox
          color="primary"
          height={height}
          checked={isGroup ? allSelectedByGroup(item?.id) : checked}
          indeterminate={isGroup ? someSelectedByGroup?.(item?.id) : false}
        />
      }
    />
  )
}

MultiSelectItem.propTypes = {
  item: PropTypes.object,
  selectAllByGroup: PropTypes.func,
  allSelectedByGroup: PropTypes.func,
  someSelectedByGroup: PropTypes.func,
  isForeign: PropTypes.bool,
  checked: PropTypes.bool,
  onClick: PropTypes.func,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

export default MultiSelectItem
